module.exports = __webpack_public_path__ + "static/media/enter_shirt_number.b1bb62d0.png";